export function dateUStoISO(val) {
	const usRegex = /(0?[1-9]|1[012])[\/](0?[1-9]|[12][0-9]|3[01])[\/]([1|2]\d\d\d)/;
	if (usRegex.test(val)) {
		const m = val.match(usRegex);
		return `${m[3]}-${m[1].padStart(2,'0')}-${m[2].padStart(2,'0')}`;
	} else {
		return false;
	}
}

export function dateISOtoUS(val) {
	const isoRegex = /([1|2]\d\d\d)[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])/;
	if (isoRegex.test(val)) {
		const m = val.match(isoRegex);
		return `${m[2]}/${m[3]}/${m[1]}`;
	} else {
		return false;
	}
}

export function dateToUS(val) {
    const isoRegex = /([1|2]\d\d\d)[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])/;
    const usRegex = /(0?[1-9]|1[012])[\/](0?[1-9]|[12][0-9]|3[01])[\/]([1|2]\d\d\d)/;
    if (isoRegex.test(val)) {
        const m = val.match(isoRegex);
        return `${m[2]}/${m[3]}/${m[1]}`;
    } else if (usRegex.test(val)) {
        return val;
    } else {
        return false;
    }
}

export function dateToString(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1) >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
    const day = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`;
    return `${year}-${month}-${day}`;
}

export function dateToUsString(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1) >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
    const day = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`;
    return `${month}/${day}/${year}`;
}

export function stringUStoISO(date) {
    if (!date.includes('/')) {
        return date;
    }
    const d = date.split('/');
    const dateWithoutTime = new Date(`${d[2]}-${d[0].length > 1 ? '' : '0'}${d[0]}-${d[1].length > 1 ? '' : '0'}${d[1]}T00:00:00`);
    const year = dateWithoutTime.getFullYear();
    const month = (dateWithoutTime.getMonth() + 1) >= 10 ? dateWithoutTime.getMonth() + 1 : `0${dateWithoutTime.getMonth() + 1}`;
    const day = dateWithoutTime.getDate() >= 10 ? dateWithoutTime.getDate() : `0${dateWithoutTime.getDate()}`;
    return `${year}-${month}-${day}`;
}

export function stringISOtoUS(date, withoutZero) {
    if (date === 'MTM') {
        return 'MTM';
    }
    const withoutZeroString = withoutZero ? '' : '0';
    const dateWithoutTime = new Date(`${date}T00:00:00`);
    const year = dateWithoutTime.getFullYear();
    const month = (dateWithoutTime.getMonth() + 1) >= 10 ? dateWithoutTime.getMonth() + 1 : withoutZeroString + (dateWithoutTime.getMonth() + 1);
    const day = dateWithoutTime.getDate() >= 10 ? dateWithoutTime.getDate() : withoutZeroString + (dateWithoutTime.getDate());
    return `${month}/${day}/${year}`;
}

export function stringUStoUS(date) {
    if (date === 'MTM') {
        return 'MTM';
    }
    const d = date.split('/');
    const dateWithoutTime = new Date(`${d[2]}-${d[0].length > 1 ? '' : '0'}${d[0]}-${d[1].length > 1 ? '' : '0'}${d[1]}T00:00:00`);
    const year = dateWithoutTime.getFullYear();
    const month = (dateWithoutTime.getMonth() + 1) >= 10 ? dateWithoutTime.getMonth() + 1 : `0${dateWithoutTime.getMonth() + 1}`;
    const day = dateWithoutTime.getDate() >= 10 ? dateWithoutTime.getDate() : `0${dateWithoutTime.getDate()}`;
    return `${month}/${day}/${year}`;
}

export function dateToTimestamp(date){
    const year = date.getFullYear();
    const month = "0" + (date.getMonth()+1);
    const day = "0" + date.getDate();
    const hours = date.getHours();
    const minutes = "0" + date.getMinutes();
    const seconds = "0" + date.getSeconds();
    return year+"-"+month.substring(month.length-2)+"-"+day.substring(day.length-2)+"T"+hours + ':' + minutes.substring(minutes.length-2) + ':' + seconds.substring(seconds.length-2);
}

export function formatHour(hour){
    if(hour && hour.includes(':')){
        let suffix = 'am';
        let formattedHour = Number(hour.split(':')[0]);
        let minutes = hour.split(':')[1];
        if(formattedHour > 12){
            suffix = 'pm';
            formattedHour = formattedHour - 12;
        }
        formattedHour = `${formattedHour}:${minutes}${suffix}`
        return formattedHour;
    }
    return hour;
}

export function splitTimestamp(timestamp){
    const timestampDate = timestamp ? dateISOtoUS(timestamp.split('T')[0]) : '';
    let timestampHour = timestamp ? formatHour(timestamp.split('T')[1]) : '';
    
    return {timestampDate, timestampHour}
}